import 'Assets/styles/default/pages/viewRedemption/ViewRedemptionStyles.less';
import React, { useEffect, useState } from 'react';
import { Typography, VertContainer, VertIcon } from '@vertem-core/vertice-ds';
import PropTypes from 'prop-types';
import { Col, Row, Table } from 'antd';
import { formatToString } from 'Utils/format';

export const SpotProducts = ({ spot, isManager }) => {
  const [products, setProducts] = useState([]);
  const [productsTotalPrice, setProductsTotalPrice] = useState(0);

  useEffect(() => {
    let _products = [];
    if (spot.products.length > 0) {
      _products = [];

      _products = spot.products.map((product) => {
        return {
          name: product.name,
          unitPrice: product.unitPrice,
          description: product.description,
          quantity: product.quantity,
          total: product.unitPrice * product.quantity,
          unitPointsPrice: product.unitPointsPrice,
          isChecked: false,
        };
      });

      if (_products.length > 0) {
        const totalPrice = _products.reduce((accumulator, object) => {
          return accumulator + object.unitPrice * object.quantity;
        }, 0);

        setProductsTotalPrice(totalPrice);
      } else {
        setProductsTotalPrice(0);
      }
    }

    setProducts(_products);
  }, []);

  const hasUndeliveredProducts = products.some((x) => x.delivery === false);

  const columns = [
    {
      title: 'Produto',
      dataIndex: 'name',
      key: 'name',
      sorter: (a, b) => a.name.length - b.name.length,
      showSorterTooltip: false,
      render: (name, product) => (
        <div>
          {name} <br />
          {isManager && (
            <Typography.Text>{product.description}</Typography.Text>
          )}
        </div>
      ),
    },
    {
      title: 'Valor solicitado',
      dataIndex: 'unitPrice',
      key: 'unitPrice',
      sorter: (a, b) => a.unitPrice - b.unitPrice,
      showSorterTooltip: false,
      render: (unitPrice, product) => (
        <div>
          {/* {formatToString(unitPrice, 'currency')} <br /> */}
          {formatToString(product.unitPointsPrice) + ' pontos'}
        </div>
      ),
    },
    {
      title: 'Quantidade',
      dataIndex: 'quantity',
      key: 'quantity',
      sorter: (a, b) => a.quantity - b.quantity,
      showSorterTooltip: false,
    },
    {
      title: 'Valor total',
      dataIndex: 'total',
      key: 'total',
      sorter: (a, b) => a.total - b.total,
      showSorterTooltip: false,
      render: (total, product) => (
        <div>
          {/* {formatToString(total, 'currency')} <br /> */}
          {formatToString(product.unitPointsPrice * product.quantity) +
            ' pontos'}
        </div>
      ),
    },
  ];

  return (
    <>
      <VertContainer className="container-subtitle-view-redemption">
        <VertIcon
          size="large"
          className="spacing-icon"
          isVertice
          iconName="Shop"
        />
        <Typography.Text className="subtitle-view-redemption">
          Produto
        </Typography.Text>
      </VertContainer>

      <VertContainer>
        <Table
          pagination={false}
          bordered
          columns={columns}
          dataSource={products}
          rowClassName={(record) => {
            return !record.delivery ? '' : 'blocked-text';
          }}
        />

        <VertContainer className="container-total-value">
          <Row>
            <Col xs={12} sm={12} md={12} lg={20} xl={20} xxl={20}>
              <VertContainer>
                <Typography.Text className="text-total-value">
                  Valor dos produtos
                </Typography.Text>
              </VertContainer>
            </Col>

            <Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}>
              <VertContainer className="col-total-value">
                <Typography.Text className="text-total-value">
                  {formatToString(
                    spot !== null ? spot.totalPrice - spot.shippingValue : 0
                  )}{' '}
                  pontos
                </Typography.Text>
              </VertContainer>
            </Col>
            <Col xs={12} sm={12} md={12} lg={20} xl={20} xxl={20}>
              <VertContainer>
                <Typography.Text className="text-total-value">
                  Valor do frete
                </Typography.Text>
              </VertContainer>
            </Col>

            <Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}>
              <VertContainer className="col-total-value">
                {spot !== null && spot.shippingValue > 0
                  ? (
                    <Typography.Text className="text-total-value">
                      {formatToString(spot.shippingValue)}{' '}
                      pontos
                    </Typography.Text>
                  ) : (
                    <Typography.Text
                      className="shipping-free-value"
                      style={{
                        fontSize: '22px',
                        fontWeight: 'bold',
                      }}
                    >
                      Grátis
                    </Typography.Text>
                  )
                }
              </VertContainer>
            </Col>
            <Col xs={12} sm={12} md={12} lg={20} xl={20} xxl={20}>
              <VertContainer>
                <Typography.Text className="text-total-value">
                  VALOR TOTAL
                </Typography.Text>
                {hasUndeliveredProducts && (
                  <Typography.Paragraph type="danger">
                    Os produtos destacados em vermelho não podem ser entregues
                    para o CEP informado. Cancele a solicitação e entre em
                    contato com o solicitante.
                  </Typography.Paragraph>
                )}
              </VertContainer>
            </Col>

            <Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}>
              <VertContainer className="col-total-value">
                <Typography.Text className="text-total-value">
                  {spot !== null &&
                    formatToString(spot.totalPoints) + ' pontos'}
                </Typography.Text>
              </VertContainer>
            </Col>
          </Row>
        </VertContainer>
      </VertContainer>
    </>
  );
};

SpotProducts.propTypes = {
  spot: PropTypes.object.isRequired,
};
